<template>
    <div class="transform">
        <div class="transform_top">积分转出到HG</div>
        <div class="transform_details am-cf">
            <p class="am-fr" @click="transDeta()">查看转出详情</p>
        </div>
        <div class="transform_con">
            <div class="transform_con_first am-cf">
                <p class="am-fl">我的积分</p>
                <p class="am-fr">0</p>
            </div>
        </div>
        <div class="transform_list">
            <div class="transform_list_block am-cf">
                <p class="transform_list_block_name am-fl"><span>*</span>用户名</p>
                <input class="am-fl" placeholder="请输入用户名" />
                <img class="am-fl" src="" />
            </div>
            <div class="transform_list_block am-cf">
                <p class="am-fl transform_list_block_name"><span>*</span>积分</p>
                <input class="am-fl" placeholder="请输入转出积分" />
                <img class="am-fl" src="" />
            </div>
            <div class="transform_list_block am-cf">
                <p class="am-fl transform_list_block_name">手机号</p>
                <input class="am-fl" placeholder="请输入手机号" />
                <img class="am-fl" src="" />
            </div>
             <div class="transform_list_block am-cf">
                <p class="am-fl transform_list_block_name">邮箱</p>
                <input class="am-fl" placeholder="请输入邮箱" />
                <img class="am-fl" src="" />
            </div>
             <div class="transform_list_block am-cf">
                <p class="am-fl transform_list_block_name">备注</p>
                <input class="am-fl" placeholder="请输入备注" />
                <img class="am-fl" src="" />
            </div>
        </div>
         <p class="transform_trip">提示：邮箱与邮箱选填一个即可</p>
        <button class="transform_but">确认转出</button>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
       
        };
    },
    mounted: function () {},
    methods: {
        transDeta:function(){
          this.$router.push({
              path:'./memmber_transDeta'
          })
      }
    },
};
</script>

<style scoped>
    .transform{width: 100%;}
    .transform_top{font-size: 18px;color: #000;line-height: 40px; text-align: center;}
    .transform_details{line-height: 45px;background-color: #fff;padding: 0 30px;}
    .transform_con{width: 100%;line-height: 35px;background-color: #fff;}
    .transform_con_first{border-bottom: 1px dashed #999;padding: 0px 30px;}
    .transform_con_first p{font-size: 16px;}
    .trans_tit{font-size: 18px;}
    .transform_but{width: 60%;height: 40px;background-color: var(--bg-color);display: block;margin: 0 auto;font-weight: bold;border-radius: 8px;margin-top: 30px!important;font-size: 15px;color: #fff;}
    .transform_list{width: 100%;background-color: #fff;padding: 0 15px;}
    .transform_list_block{display: flex;align-items: center;line-height: 35px;}
    .transform_list_block_name{width: 20%;text-align: center;}
    .transform_list_block_name span{color: rgb(214, 16, 16);}
    .transform_trip{color: rgb(214, 16, 16);font-size: 14px;line-height: 45px;padding: 0 30px;}
</style>
